"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryParseBoolean = void 0;
/**
 * Parsuje kolejne wartości, zwracając pierwszą, której można przypisać wartość typu bool
 *
 * @export
 * @param {...any[]} values
 * @returns {boolean}
 */
function tryParseBoolean(...values) {
    for (const value of values) {
        if (value === true || value === 'true' || value === 1 || value === '1') {
            return true;
        }
        if (value === false || value === 'false' || value === 0 || value === '0') {
            return false;
        }
    }
    return undefined;
}
exports.tryParseBoolean = tryParseBoolean;
//# sourceMappingURL=tryParseBoolean.js.map